import { onGlobalSetup, ssrRef, provide } from '@nuxtjs/composition-api';
import { loadGoogleTagManager } from '../scripts/tagmanager';

export default ({ route, $cookies }, inject) => {
  onGlobalSetup(() => {
    const isDevMode = () => {
      if (route?.query?.['dev-notracking'] !== undefined) {
        $cookies.set('dev-notracking', 1, {
          path: '/',
          maxAge: 60 * 60 * 24 * 30, // 30 güns
        });
        return true;
      }
      return $cookies.get('dev-notracking') || route.query?.notracking !== undefined;
    };
    if (isDevMode() === false) {
      loadGoogleTagManager();
    }

    // Data Layer Impression & Click Mechanism
    const customDataLayer = ssrRef({ ua: [], ga: [] });
    provide('dataLayer', customDataLayer);
    if (process.client) {
      window.addEventListener('load', () => {
        if (customDataLayer.value.ga.length) {
          window.dataLayer.push({
            ecommerce: null,
          });
          window.dataLayer.push({
            event: 'view_item_list', // Sabit olarak bu değer yazılmalıdır.
            ecommerce: {
              ...customDataLayer.value?.type,
              items: customDataLayer.value.ga,
            },
          });
          customDataLayer.value.ga = [];
        }
      });
      let timer = null;
      window.addEventListener(
        'scroll',
        () => {
          if (timer !== null) {
            clearTimeout(timer);
          }
          timer = setTimeout(function () {
            if (customDataLayer.value.ga.length) {
              window.dataLayer.push({
                ecommerce: null,
              });
              window.dataLayer.push({
                event: 'view_item_list', // Sabit olarak bu değer yazılmalıdır.
                ecommerce: {
                  ...customDataLayer.value?.type,
                  items: customDataLayer.value.ga,
                },
              });
              customDataLayer.value.ga = [];
            }
          }, 150);
        },
        false
      );
      window.onunload = function () {
        if (customDataLayer.value.ga.length) {
          window.dataLayer.push({
            ecommerce: null,
          });
          window.dataLayer.push({
            event: 'view_item_list', // Sabit olarak bu değer yazılmalıdır.
            ecommerce: {
              items: customDataLayer.value.ga,
            },
          });
          customDataLayer.value.ga = [];
        }
      };
    }
  });
  // TODO: Will implement data layer version of it
  inject('analyticsEvent', (category, action, label, value) => {
    if (!window.gtag) return;
    window.gtag('event', action, {
      event_category: window.require('info').page.viewScope === 'mobile' ? `Mobile_${category}` : `Desktop_${category}`,
      event_label: label,
      value,
    });
  });
};
